import { useEffect } from "react";

const ExternalRedirect = ({ url }) => {
  useEffect(() => {
    window.location.href = url;
  }, [url]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
      <p className="text-white">Redirecting...</p>
    </div>
  );
};

export default ExternalRedirect;
